<template>
  <v-row dense justify="center" class="mt-5">
    <v-col
      v-for="indicador in Object.keys(dadosTotais)"
      :key="indicador"
      cols="5"
      sm="3"
      md="auto"
      class="flex-md-grow-1"
    >
      <v-card class="my-1 elevation-0">
        <v-card-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <h5 v-on="on">{{ indicador | toUpperCase }}</h5>
            </template>
            <span>{{ traducaoIndicadores[indicador] }}</span>
          </v-tooltip>

          <status-evolucao-kpis
            class="ml-1"
            :valorAtual="dadosTotais[indicador] || 0"
            :valorAnterior="dadosTotaisCompetenciaAnterior[indicador] || 0"
          />
        </v-card-title>

        <div
          v-if="loading"
          class="d-flex align-center justify-center"
          style="height: 50px;"
        >
          <v-progress-circular indeterminate color="primary" size="32" />
        </div>

        <v-card-text v-else>
          <div class="display-3">
            {{
              dadosTotais[indicador] === null
                ? "-"
                : dadosTotais[indicador] | parseNumberToFloatBrIgnoringNaN
            }}
            <span v-if="['pla', 'pla+e'].includes(indicador)">%</span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DashboardLnoVisaoAneelIndicadores",
  components: {
    StatusEvolucaoKpis: () =>
      import("@/components/dashboardLno/StatusEvolucaoKpis.vue"),
  },
  props: {
    dadosTotais: {
      type: Object,
      default: () => ({}),
    },
    dadosTotaisCompetenciaAnterior: {
      type: Object,
      default: () => ({}),
    },
    traducaoIndicadores: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
